/*
 * 政务行业
 */
import React from 'react';
import SkeletonNew from 'components/solution/skeletonNew';
import { headBg, headBgM, challenge, frameSrc, frameSrcM, frame, advantage, scene, caseList } from 'constants/solution/gov-solution';

const GovAffair = () => {
  return (
    <SkeletonNew
      headFixed={true}
      challenge={challenge}
      caseList={caseList}
      advantage={advantage}
      scene={scene}
      frame={frame}
      headBg={headBg}
      headBgM={headBgM}
      title="政务行业解决方案"
      simpleDesc="赋能数字政府 让政务服务零距离"
      desc={`小鱼易连提供自主创新云视频技术和政务云视频顶层设计方案，将云视频应\n用从会议室延展到个人互联、移动接入、融合调度、政务服务等多场景，全\n面提升政务数字化水平，助力政府数字化转型。`}
      pageTitle="政务行业"
      tdkWord="govSolution"
      frameSrc={frameSrc}
      frameSrcM={frameSrcM}
    />
  );
};

export default GovAffair;
